import React from 'react';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback
} from '../../lib/helpers';

import {useModal} from '../../hooks';
import Modal from '.././Modal';

const AddUnlockedEmplTool = ({bagId, yayUserId}) => {
  const [modal, modalSet] = useModal({ keyboardBindings: true })

  const handleSubmit = (e) => {
    e.preventDefault()
    const elements = e.target.elements
    const amount = elements.unlocked_empl_amount.value
    const confirmMessage = `Are you sure you want to send ${amount} unlocked EMPL to User ID ${yayUserId}?`
    const confirmation = window.confirm(confirmMessage)
    if (confirmation) {
      requestCallback(axios.post(`/${gon.currentProvider}/bag/${bagId}/add_unlocked_empl`, {
        unlocked_empl_amount: amount,
        authenticity_token: CSRF_TOKEN,
        yay_user_id: yayUserId
      }))
    }
  }

  return (
    <React.Fragment>
      <a className='Badge Badge--green Badge--spaced' onClick={() => modalSet(true)}>
        Add unlocked EMPL
      </a>
      <Modal isActive={modal} onToggleModal={() => modalSet(false)} reset>
        <div className='EditModal'>
          <h3 className='Modal__h3'>Add unlocked EMPL</h3>
          <form
            className='EditModal__form'
            onSubmit={handleSubmit}
          >
          <div className="Container__form__col AddEmplTool">
            <label className='Container__form__label'>Amount</label>
            <input
              type='number'
              min='1'
              max='10000'
              className='Input'
              name='unlocked_empl_amount'
              placeholder='amount of EMPL'
              required
            />

            <div className='EditModal__form__buttons'>
              <button type="button"
                className='Button Button--gray-light'
                onClick={() => modalSet(false)}
              >
                Cancel
              </button>

              <button type="submit" className='Button Button--green'>
                Submit
              </button>
            </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default AddUnlockedEmplTool